<template>
	<div class="kangfu_video" @click="onClick">
		<div class="kangfu_video_file">
			<img :src="item.coverUrl" />
		</div>
		<div class="kangfu_video_title van-multi-ellipsis--l2">{{ item.videoName }}</div>
	</div>
</template>
<script>
export default {
    name: 'kangfuVideo',
    props: {
        item: {
            type: Object,
            default: () => { }
        }
    },
    methods: {
        onClick () {
            this.$router.push({
                path: `/information/kagfu/${this.item.id}`
            })
        }
    }
}
</script>
<style lang="less" scoped>
.kangfu_video {
	background-color: #ffffff;
	float: left;
	margin-right: 20px;
	width: 250px;
	height: 248px;
	margin-bottom: 20px;
	border-radius: 12px;

	box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.11);
	overflow: hidden;
	&_file {
		height: 140px;
		img {
			width: 100%;
			height: 100%;
		}
	}
	&_title {
		padding: 16px;
		font-size: 26px;
		color: #1f2329;
		font-weight: bold;
		height: 62px;
		overflow: hidden;
	}
}
</style>